export const AuthStep = {
  PROFILE: 'profile',
  GEO_AREA: 'geo-area',
  TERMS: 'terms',
  VERSION: 'version'
} as const;

export type AuthStep = (typeof AuthStep)[keyof typeof AuthStep];
